export default {
  businessLeadsList: [],
  lastSyncBusinessLeads: null,
  lastSyncProspectingBuyers: null,
  prospectingBuyers: [],
};
